{
  "status": {
    "draft": "Чернетка",
    "published": "Опубліковано",
    "archived": "В архіві"
  },
  "attemptStatus": {
    "in_progress": "Триває",
    "submitted": "Очікує перевірки",
    "graded": "Оцінено"
  },
  "questionType": {
    "single_choice": "Одна правильна відповідь",
    "multiple_choice": "Кілька правильних відповідей",
    "short_text": "Коротка відповідь",
    "open": "Розгорнута відповідь"
  },
  "list": {
    "title": "Тести",
    "description": "Тести й перевірні роботи, які ви створюєте, задаєте та оцінюєте.",
    "searchPlaceholder": "Пошук тестів…",
    "statusFilter": "Статус",
    "courseFilter": "Курс",
    "anyStatus": "Будь-який статус",
    "anyCourse": "Будь-який курс",
    "questions": "{{count}} запитання",
    "questions_few": "{{count}} запитання",
    "questions_many": "{{count}} запитань",
    "questions_other": "{{count}} запитань",
    "assignedTo": "Задано класам",
    "notAssigned": "Ще не задано",
    "noTimeLimit": "Без обмеження часу",
    "timeLimit": "{{minutes}} хв",
    "empty": {
      "title": "Тестів ще немає",
      "text": "Створіть перший тест, додайте запитання й задайте його класу.",
      "filterText": "За обраними фільтрами нічого не знайдено."
    },
    "actions": {
      "edit": "Редагувати",
      "view": "Переглянути",
      "attempts": "Спроби",
      "publish": "Опублікувати",
      "unpublish": "Зняти з публікації",
      "duplicate": "Дублювати",
      "archive": "Архівувати",
      "more": "Інші дії для «{{title}}»"
    },
    "published": "Тест опубліковано",
    "unpublished": "Тест повернуто в чернетки",
    "duplicated": "Тест продубльовано",
    "archived": "Тест архівовано",
    "archiveTitle": "Архівувати «{{title}}»?",
    "archiveDescription": "Тест одразу зникне в усіх учнів. Уже зроблені спроби й оцінки залишаться.",
    "moduleFilter": "Модуль",
    "anyModule": "Усі модулі",
    "kindFilter": "Тип роботи",
    "anyKind": "Усі типи"
  },
  "create": {
    "button": "Створити тест",
    "title": "Створення тесту",
    "description": "Дайте назву — налаштування й запитання додасте далі.",
    "titleLabel": "Назва тесту",
    "titlePlaceholder": "напр. Дроби — підсумкова робота",
    "submit": "Створити тест",
    "success": "Тест створено",
    "failed": "Не вдалося створити тест"
  },
  "builder": {
    "title": "Конструктор тесту",
    "back": "До списку тестів",
    "attempts": "Спроби",
    "settings": "Налаштування",
    "testTitle": "Назва тесту",
    "descriptionLabel": "Опис",
    "course": "Курс",
    "noCourse": "Без курсу",
    "lesson": "Урок",
    "noLesson": "Без уроку",
    "timeLimit": "Обмеження часу (хвилин)",
    "timeLimitHint": "Залиште порожнім, щоб не обмежувати час.",
    "maxAttempts": "Дозволено спроб",
    "shuffleQuestions": "Перемішувати запитання",
    "shuffleAnswers": "Перемішувати варіанти відповідей",
    "showCorrectAnswers": "Показувати правильні відповіді після оцінювання",
    "availableFrom": "Доступний з",
    "availableUntil": "Доступний до",
    "save": "Зберегти налаштування",
    "saved": "Налаштування збережено",
    "saveFailed": "Не вдалося зберегти налаштування",
    "publish": "Опублікувати",
    "unpublish": "Зняти з публікації",
    "duplicate": "Дублювати",
    "archive": "Архівувати",
    "assign": "Задати класу",
    "frozen": "У цього тесту вже є спроби, тому запитання заблоковано. Продублюйте тест, щоб змінити їх.",
    "questions": {
      "title": "Запитання",
      "empty": "Запитань ще немає — додайте перше нижче.",
      "add": "Додати запитання",
      "position": "Запитання {{index}}",
      "text": "Текст запитання",
      "points": "Бали",
      "moveUp": "Перемістити запитання вгору",
      "moveDown": "Перемістити запитання вниз",
      "delete": "Видалити запитання",
      "deleteTitle": "Видалити це запитання?",
      "deleteDescription": "Запитання разом із правильними відповідями буде вилучено з тесту.",
      "save": "Зберегти запитання",
      "saved": "Запитання збережено",
      "added": "Запитання додано",
      "deleted": "Запитання видалено"
    },
    "choices": {
      "label": "Варіанти",
      "add": "Додати варіант",
      "remove": "Видалити варіант {{index}}",
      "text": "Варіант {{index}}",
      "correctSingle": "Позначити варіант {{index}} як правильну відповідь",
      "correctMultiple": "Варіант {{index}} правильний",
      "correct": "Правильний",
      "hintSingle": "Правильним має бути рівно один варіант.",
      "hintMultiple": "Позначте всі правильні варіанти — учень отримає бали, лише обравши їх усі."
    },
    "accepted": {
      "label": "Прийнятні відповіді",
      "add": "Додати відповідь",
      "placeholder": "Введіть відповідь і натисніть Enter",
      "remove": "Видалити відповідь «{{value}}»",
      "hint": "Регістр і зайві пробіли не враховуються."
    },
    "open": {
      "hint": "Розгорнуті відповіді ви оцінюєте вручну у списку спроб."
    },
    "readOnly": {
      "title": "Цей тест можна переглядати, але не редагувати",
      "text": "Він належить іншому вчителю. Змінювати його можуть лише адміністратор школи, автор тесту або вчитель класу, якому тест задано. Продублюйте тест, щоб отримати власну копію.",
      "duplicate": "Дублювати, щоб редагувати"
    },
    "kind": "Вид роботи"
  },
  "assign": {
    "title": "Задати класу",
    "description": "Учні класу побачать тест, коли він опублікований і відкритий у період доступності.",
    "classLabel": "Клас",
    "classPlaceholder": "Оберіть клас",
    "dueAt": "Термін (необовʼязково)",
    "submit": "Задати",
    "success": "Тест задано класу",
    "current": "Уже задано",
    "none": "Поки не задано жодному класу.",
    "noClasses": "Немає активних класів — спершу створіть клас.",
    "due": "До {{date}}",
    "noDue": "Без терміну",
    "unassign": "Прибрати клас {{name}}",
    "unassignTitle": "Прибрати «{{name}}»?",
    "unassignDescription": "Тест одразу зникне в учнів цього класу. Уже зроблені спроби залишаться.",
    "unassigned": "Клас прибрано",
    "validation": "Оберіть клас",
    "unassignConfirm": "Прибрати"
  },
  "attempts": {
    "title": "Спроби",
    "description": "Усі спроби учнів у тесті «{{title}}».",
    "back": "Назад до тесту",
    "pupil": "Учень",
    "attemptNumber": "Спроба {{number}}",
    "status": "Статус",
    "score": "Бали",
    "submitted": "Здано",
    "needsGradingOnly": "Лише ті, що чекають перевірки",
    "empty": "Спроб ще немає.",
    "open": "Перевірити",
    "notSubmitted": "—"
  },
  "grading": {
    "title": "Перевірка спроби {{number}}",
    "back": "Назад до спроб",
    "pupilAnswer": "Відповідь учня",
    "noAnswer": "Відповіді немає",
    "autoGraded": "Оцінено автоматично",
    "earned": "{{points}} / {{max}}",
    "pointsLabel": "Бали (максимум {{max}})",
    "feedbackLabel": "Коментар (необовʼязково)",
    "submit": "Зберегти оцінки",
    "saved": "Оцінки збережено",
    "failed": "Не вдалося зберегти оцінки",
    "inProgress": "Спроба ще триває — оцінити її поки не можна.",
    "noOpenQuestions": "У тесті немає запитань із розгорнутою відповіддю — його оцінено автоматично.",
    "total": "Разом: {{score}} / {{max}}"
  },
  "pupilList": {
    "title": "Тести",
    "description": "Тести, якими з вами поділилися вчителі.",
    "empty": {
      "title": "Зараз немає тестів",
      "text": "Тут з’являються тести, які вчителі відкривають для ваших класів, і ваші результати після перевірки."
    },
    "window": "Відкрито до {{date}}",
    "opens": "Відкриється {{date}}",
    "attemptsLeft": "Залишилася {{count}} спроба",
    "attemptsLeft_few": "Залишилося {{count}} спроби",
    "attemptsLeft_many": "Залишилося {{count}} спроб",
    "attemptsLeft_other": "Залишилося {{count}} спроб",
    "noAttemptsLeft": "Спроб не залишилося",
    "noAttemptsLeftHint": "Ви використали всі спроби цього тесту. Якщо потрібна ще одна — зверніться до вчителя.",
    "bestScore": "Найкращий результат: {{score}} / {{max}}",
    "lastAttempt": "Остання спроба: {{status}}",
    "start": "Почати",
    "resume": "Продовжити",
    "startTitle": "Почати «{{title}}»?",
    "startDescriptionSingle": "У вас лише одна спроба. Щойно почнете — вона зарахується.",
    "startDescriptionTimed": "Відлік почнеться одразу: {{minutes}} хв.",
    "startFailed": "Не вдалося почати тест",
    "questionsCount": "{{count}} запитання",
    "questionsCount_few": "{{count}} запитання",
    "questionsCount_many": "{{count}} запитань",
    "questionsCount_other": "{{count}} запитань",
    "totalPoints": "Балів: {{points}}",
    "yourResult": "Ваш результат",
    "awaitingGrading": "Очікує оцінювання — результат зʼявиться, щойно вчитель перевірить роботу"
  },
  "take": {
    "back": "До списку тестів",
    "question": "Запитання {{index}} з {{total}}",
    "points": "Балів: {{points}}",
    "shortTextPlaceholder": "Ваша відповідь",
    "openPlaceholder": "Напишіть відповідь",
    "answerLabel": "Ваша відповідь",
    "saving": "Зберігаємо…",
    "saved": "Усі відповіді збережено",
    "saveFailed": "Не вдалося зберегти — пробуємо ще раз",
    "retry": "Спробувати зараз",
    "timeLeft": "Залишилось {{time}}",
    "timeAlmostUp": "Менше хвилини до кінця",
    "timeUp": "Час вичерпано — ваші відповіді надіслано.",
    "submit": "Здати тест",
    "submitTitle": "Здати відповіді?",
    "submitDescription": "Після здачі змінити відповіді вже не можна.",
    "unanswered": "Ще {{count}} запитання без відповіді.",
    "unanswered_few": "Ще {{count}} запитання без відповіді.",
    "unanswered_many": "Ще {{count}} запитань без відповіді.",
    "unanswered_other": "Ще {{count}} запитань без відповіді.",
    "submitFailed": "Не вдалося здати тест",
    "alreadySubmitted": "Цю спробу вже здано."
  },
  "result": {
    "title": "Ваш результат",
    "awaitingGrading": "Здано. Учитель ще має перевірити розгорнуті відповіді.",
    "score": "{{score}} / {{max}}",
    "scoreLabel": "Бали",
    "gradeLabel": "Оцінка",
    "perQuestion": "За запитаннями",
    "earned": "{{points}} / {{max}} балів",
    "correct": "Правильно",
    "incorrect": "Неправильно",
    "correctAnswer": "Правильна відповідь",
    "correctAnswers": "Правильні відповіді",
    "acceptedAnswers": "Прийнятні відповіді",
    "feedback": "Коментар учителя",
    "yourAnswer": "Ваша відповідь",
    "backToTests": "До списку тестів"
  },
  "validation": {
    "titleRequired": "Вкажіть назву",
    "pointsRange": "Бали мають бути додатним числом"
  },
  "linkedSection": {
    "lessonTitle": "Тести до цього уроку",
    "courseTitle": "Тести до цього курсу",
    "create": "Створити тест",
    "empty": "Сюди ще не привʼязано жодного тесту.",
    "questions_one": "{{count}} запитання",
    "questions_few": "{{count}} запитання",
    "questions_many": "{{count}} запитань",
    "questions_other": "{{count}} запитання"
  },
  "kinds": {
    "current": "Поточна робота",
    "independent": "Самостійна робота",
    "control": "Контрольна робота",
    "thematic": "Тематична",
    "diagnostic": "Діагностична"
  }
}
